<template>
    <ul v-if="!allowMinified" class="provider-list"
        :class="[selectedProvider && isMobile ? (`content-${selectedProvider.name !== 'los-toestel' ? lowercaseProvider(selectedProvider.name) : 'default'}`) : '']"
    >
        <li :class="[{ active : !selectedProvider },'even', 'fp-0']">
            <provider :provider="null" :selected-filters="selectedFilters"/>
        </li>

        <template
            v-for="(provider, index) in providerList"
            :key="index"
        >
            <li v-if="selectedProvider"
                :class="[
                    { active : provider.name === selectedProvider.name },
                    lowercaseProvider(provider.name),
                    index % 2 === 1 ? 'even' : 'odd',
                    `fp-${index + 1}`
                    ]"
            >
                <provider
                    :key="index"
                    :provider="provider"
                    :selected-filters="selectedFilters"
                    :alternative-offer="alternativeOffers[provider.name] || null"
                />
            </li>

            <li v-if="!selectedProvider"
                :class="['active', index % 2 === 1 ? 'even' : 'odd', `fp-${index + 1}`]"
            >
                <provider
                    :provider="provider"
                    :selected-filters="selectedFilters"
                    :key="index"
                    :alternative-offer="alternativeOffers[provider.name] || null"
                />
            </li>

            <li v-if="index % 2 !== 1 && index !== providerList.length - 1"
                class="line-break"
            ></li>
        </template>

        <li v-if="providerList.length % 2" class="line-break"></li>

        <li :class="[
            providerList.length % 2 === 1 ? 'even' : 'odd',
            `fp-${providerList.length + 1}`,
            {active: selectedProvider  && selectedProvider.name === 'los-toestel'},
            'los-toestel'
        ]">
            <provider :provider="{name: 'los-toestel'}" :selected-filters="selectedFilters"/>
        </li>
    </ul>

    <ul v-else :class="['provider-list', `content-${selectedProvider.name !== 'los-toestel' ? lowercaseProvider(selectedProvider.name) : 'default'}`]">
        <li class="even fp-0">
            <provider :provider="null" :selected-filters="selectedFilters"/>
        </li>

        <li :class="['active', lowercaseProvider(selectedProvider.name), 'odd', 'fp-1']">
            <provider :provider="selectedProvider" :selected-filters="selectedFilters"/>
        </li>
    </ul>
</template>

<script>
import Provider from './Provider';

export default {
    components: {
        Provider
    },

    props: {
        providerList: {
            type: Array,
            default: null
        },

        selectedFilters: {
            type: Object,
            default: null
        },

        selectedProvider: {
            type: Object,
            default: null
        },

        allowMinified: {
            type: Boolean,
            default: false
        },

        alternativeOffers: {
            type: Object,
            default: () => []
        },
    },

    data() {
        return {

        }
    },

    methods: {
        lowercaseProvider(provider) {
            return this.$filters.lowerCase(provider)
        },
    }
}
</script>
